import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { ConversionInfo } from '../interfaces/ConversionIf'
import { LanguageContext } from '../util/LanguageContext'
import { ConversionItemButton } from './ConversionItemButton'

type ConversionListProps = {
  items: ConversionInfo[]
  onDeleteConversion: (preText: string) => void
  onUpdateConversion: (oldPreText: string, newPreText: string, newPostText: string) => void
}
export const ConversionList: React.FC<ConversionListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)
  return (
    <>
      {props.items.map(conversion => (
        <Grid key={conversion.conversion_id} item lg={12} xl={6}>
          <ConversionItemButton
            title={translation['label_forceword']}
            id={conversion.conversion_id}
            pre_text={conversion.pre_text}
            post_text={conversion.post_text}
            onDel={props.onDeleteConversion.bind(null, conversion.pre_text)}
            onUpdate={(oldPre, newPre, newPost) => props.onUpdateConversion(oldPre, newPre, newPost)}
          />
        </Grid>
      ))}
    </>
  )
}
